<template>
  <div class="home">
    <RegisterWindow msg="Dobrý den"/>
  </div>
</template>

<script>
// @ is an alias to /src
import RegisterWindow from '@/components/RegisterWindow.vue'

export default {
  name: 'RegisterView',
  components: {
    RegisterWindow
  },


  
}
</script>
